<bootstrap-popup
	[id]="id"
	[displaySubject]="displayState$" 
	[title]="'Création des accès planifiés'"
	[modalSize]="'modal-xl'"
	[windowCloseButton]="true"
	>
	<div class="panel panel-default" *ngIf="step === 1">
		<div class="panel-heading"><h3>Choix des parcs concern&eacute;s</h3></div>
		<div class="panel-body tablecontainer">
			<div style="text-align: center">
				<label class="checkbox-line">
					<input type="checkbox"
						id="tous"
						[ngModel]="allSelected"
						(ngModelChange)="changeAllSelected($event)"
						/>
					Tous
				</label>
				<ng-container *ngFor="let technology of technologies">
					&nbsp;
					<label class="checkbox-line">
						<input type="checkbox"
							id="{{ 'tech' + technology.id }}"
							[ngModel]="technologySelected[technology.id]"
							(ngModelChange)="changeTechnologySelected(technology, $event)"
							/>
						{{ technology.label }}
					</label>
				</ng-container>
			</div>
			<div class="antennes">
				<div *ngFor="let antenne of antennes"
					class="antenne"
					>
					<div>
						<label class="checkbox-line">
							<input type="checkbox"
								id="antenne_{{ antenne.entity.id }}"
								[ngModel]="antennesSelected[antenne.entity.id]"
								(ngModelChange)="changeAntenneSelected(antenne, $event)"
								/>
							Antenne&nbsp;:&nbsp;{{ antenne.entity.nom }}
						</label>
					</div>
					<div *ngFor="let parc of antenne.parcs">
						&nbsp;&nbsp;
						<label class="checkbox-line">
							<input type="checkbox"
								id="parc_{{ parc.id }}"
								[ngModel]="parcsSelected[parc.id]"
								(ngModelChange)="changeParcSelected(antenne, parc, $event)"
								/>
							{{ parc.code }}
							({{ parc.description }} -
							<span style="color: red">{{ parc.energie }}</span> -
							<span style="color: green">{{ parc.type }}</span>)
						</label>
					</div>
				</div>
			</div>
			<div class="actions">
				<button
					type="button"
					class="btn btn-default"
					(click)="cancel()"
					>
					Annuler
				</button>&nbsp;
				<button
					type="button"
					class="btn btn-primary"
					[disabled]="noSelection"
					(click)="next()"
					>
					Suivant
				</button>
			</div>
		</div>
	</div>
	<div class="panel panel-default" *ngIf="step === 2">
		<div class="panel-heading"><h3>Information des acc&egrave;s</h3></div>
		<div class="panel-body tablecontainer">
			<form role="form" class="form-horizontal">
				<table class="table table-striped acces-intervenants" style="margin-bottom: 0px">
					<thead>
						<tr>
							<th></th>
							<th>R&ocirc;le</th>
							<th>Entreprise *</th>
							<th>Intervenant *</th>
							<th><i class="fa fa-phone-square"></i> &nbsp; <i class="fa fa-envelope"></i></th>
							<th>Habilitations</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let input of (intervenantsInputs$ | async); let index = index">
							<td class="text-center">
								<span class="clickable" *ngIf="index != 0">
									<i class="fa fa-trash fa-2x text-danger" (click)="removeIntervenantInput(index)"></i>
								</span>
							</td>
							<td style="padding-top: 14px">
								{{ index === 0 ? 'Chargé d\'accès*' : 'Intervenant' }}
							</td>
							<td>
								<filterable-select
									[inputClass]="'form-control'"
									[list]="entreprisesSelectionables"
									[labelGetter]="getEntrepriseNom"
									[selectedItem]="input.entreprise"
									(selectedItemChange)="onEntrepriseChange(input, $event)"
									>
								</filterable-select>
							</td>
							<td>
								<filterable-select *ngIf="input.entreprise"
									[inputClass]="'form-control'"
									[list]="intervenantsSelectionablesByEntreprise[input.entreprise.id]"
									[labelGetter]="getIntervenantNom" 
									[selectedItem]="input.intervenant"
									(selectedItemChange)="onIntervenantChange(input, $event)"
									>
								</filterable-select>
								<filterable-select *ngIf="!input.entreprise"
									[inputClass]="'form-control'"
									[list]="intervenantsSelectionables"
									[labelGetter]="getIntervenantNom" 
									[selectedItem]="input.intervenant"
									(selectedItemChange)="onIntervenantChange(input, $event)"
									>
								</filterable-select>
							</td >
							<td class="infosChargeAcces">
								<div *ngIf="input.intervenant && !input.modificationContacts">
									<span>
										{{ input.indicatifTelephone ? input.indicatifTelephone.dialCode : '' }}&nbsp;{{ input.telephone }}
										<i class="fa fa-pencil-square-o" title='Modifier les coordonnées' (click)="input.modificationContacts = true"></i>
									</span>
									<span>{{ input.email }}</span>
								</div>
								<div *ngIf="input.intervenant && input.modificationContacts"
									class="intervenant-inline"
									(keydown.enter)="onInputModificationContact(input)"
									(keydown.escape)="onCancelModificationContact(input)"
									>
									<div class="col-sm-5">
										<filterable-select
											[inputClass]="'form-control'" 
											[list]="indicatifTelephoneOptions"
											[labelGetter]="getIndicatifLabel" 
											[selectedItem]="input.indicatifTelephone"
											(selectedItemChange)="input.indicatifTelephone = $event"
											>
										</filterable-select>
									</div>
									<div class="col-sm-7">
										<input class="form-control" type="text" id="phone" name="phone" [(ngModel)]="input.telephone" maxlength="15" oninput="this.value = this.value.replace(/\D/g, '')" />
							 		</div>
								</div>
								<div *ngIf="input.intervenant && input.modificationContacts"
									class="intervenant-inline col-sm-12 email-editor" 
									(keydown.enter)="onInputModificationContact(input)"
									(keydown.escape)="onCancelModificationContact(input)"
									>
									<div class="col-sm-11">
										<input class="form-control" type="text" id="email" name="email" [(ngModel)]="input.email" maxlength="255" />
									</div>
									<div class="col-sm-1">
										<i class="fa-regular fa-floppy-disk fa-2x" title='Enregistrer vos modifications' (click)="onInputModificationContact(input)"></i>
									</div>
								</div>
							</td>
							<td class="habilitations-inter">
								<intervenant-status *ngIf="input.intervenant" [idIntervenant]="input.intervenant ? input.intervenant.id : 0" [extended]="false" [spacing]="'10px'" [pdpIconsToShow]="input.displayablePdpTypes" ></intervenant-status>
							</td>
						</tr>
						<tr>
							<td></td>
							<td colspan="5">
								<button type="button" class="btn btn-primary btn-sm" (click)="addIntervenantInput()">
									Ajouter
								</button>
							</td>
						</tr>
					</tbody>
				</table>
				<div class="form-group">
					<label for="heureDebut" class="col-md-1 plus-half control-label">Heure de d&eacute;but&nbsp;*:</label>
					<div class="col-sm-1 col-xs-9">
						<time-input
							[id]="'heureDebut'"
							[localTime]="heureDebut$ | async"
							(localTimeChange)="heureDebut$.next($event)"
							>
						</time-input>
					</div>
					<label for="dateDebut" class="col-sm-1 col-xs-1 control-label">le&nbsp;*:</label>
					<div class="col-sm-2 col-xs-9">
						<date-input 
							[id]="'dateDebut'"
							[localDate]="dateDebut$ | async"
							(localDateChange)="dateDebut$.next($event)"
						>
						</date-input>
					</div>
				</div>
				<div class="form-group">
					<label for="astreinte" class="col-md-1 plus-half control-label">Astreinte&nbsp;?</label>
					<div class="col-md-10 plus-half">
						<label class="radio-inline" *ngFor="let option of ouiNonOptions; let indexOption = index">
							<input type="radio"
								[name]="'astreinte'"
								[id]="'astreinte_' + indexOption"
								[value]="option.value"
								disabled
								required
								[ngModel]="astreinte$ | async"
							/>
							{{ option.label }}
						</label>
					 </div>
				</div>
				<div class="form-group">
					<label class="col-md-1 plus-half control-label">Op&eacute;ration li&eacute;e&nbsp;:</label>
					<div class="col-md-10 plus-half">
						<label class="control-label">AGR-TNIC</label>
					</div>
				</div>
				<div class="actions">
					<button
						type="button"
						class="btn btn-default"
						(click)="cancel()"
						>
						Annuler
					</button>&nbsp;
					<button
						type="button"
						class="btn btn-warning"
						(click)="previous()"
						>
						Retour
					</button>&nbsp;
					<button
						type="button"
						class="btn btn-primary"
						(click)="planify()"
						>
						Planifier
					</button>
				</div>
			</form>
		</div>
	</div>
	<div class="panel panel-default" *ngIf="step === 3">
		<div class="panel-heading"><h3>Cr&eacute;ation des acc&egrave;s</h3></div>
		<div class="panel-body tablecontainer">
			<job-progress
				[jobExecutionId]="runningJobId"
				(jobCompleted)="jobCompleted = true"
				>
			</job-progress>
			<br/>
			<form role="form" class="form-horizontal">
				<div class="actions">
					<button
						type="button"
						class="btn btn-primary"
						[disabled]="!jobCompleted"
						(click)="finish()"
						>
						Fermer
					</button>
				</div>
			</form>
		</div>
	</div>
</bootstrap-popup>